<template>

<app-page title="Clinic Report" :back="{name: 'Dashboard', query: { patient: $route.params.patient }}">

    <app-panel :title="title" :is-loading="is.loading && !is.initialised" :is-empty="is.empty">

        <app-table>
            <thead>
                <tr>
                    <th width="100">Reference</th>
                    <th>Question</th>
                    <th>Response</th>
                    <th align="center" width="80">Completed</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in collection" :key="item.id">
                    <td>{{ item.reference }}</td>
                    <td>{{ item.question }}</td>
                    <td>{{ item.response }}</td>
                    <td align="center"><div class="completed" :class="{'is-active': item.completed}" /></td>
                </tr>   
            </tbody>
        </app-table>

    </app-panel>

</app-page>

</template>

<script>

import mixCollection from '@/mixin/collection'
import Vue from 'vue'

export default {

    mixins: [mixCollection],

    data: function() {
    
        return {
            api: ['domain', this.$route.params.domain, this.$route.params.patient],
            patient: false
        }
    
    },

    computed: {
    
        title: function() {
        
            return (!this.is.loading) ? [this.patient.name, 'Domain ' + this.$route.params.domain].join(' > ') : false
        
        }

    },

    methods: {
    
        afterLoad: function(json) {
        
            Vue.set(this, 'patient', json.patient)
        
        }
    
    }

}

</script>

<style scoped>

.completed {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-size: 24px 24px;
    background-repeat: no-repeat;
    background-image: url(~@/assets/icon.cross.png);
}

.completed.is-active {
    background-image: url(~@/assets/icon.tick.png);
}

</style>